import React from 'react';
import classnames from 'classnames';
import styles from './discussionButton.module.scss';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ProposalEntity, RootState } from 'v2/models';
import { ReactComponent as AlertIcon } from 'v2/icons/alert-icon-red.svg';
import { ReactComponent as CommentDotsFilled } from 'v2/icons/commentDotsFilled.svg';
import { colleagueAssignedText } from '../AssignedColleagueIndicator';

export interface DiscussionButtonProps {
  proposal: ProposalEntity;
}

const DiscussionButton = ({ proposal }: DiscussionButtonProps) => {
  const history = useHistory();
  const user = useSelector((state: RootState) => state.user.user);
  const isOriginalResponder =
    proposal.data_provider_response?.submitted_by?.username === user.username;

  return isOriginalResponder ? (
    <div>
      <Button
        className={classnames('btn-secondary-dark', 'mt-4')}
        variant="secondary"
        onClick={() => history.push(`/discussions/${proposal.id}`)}
      >
        <CommentDotsFilled className="mr-2" />
        go to discussion
      </Button>
    </div>
  ) : (
    <div>
      <Button
        className={classnames('mt-4', styles.notResponderButton)}
        variant="secondary"
        disabled
      >
        <AlertIcon className={classnames(styles.alertIcon)} />
        {colleagueAssignedText}
      </Button>
    </div>
  );
};

export default DiscussionButton;
